import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { PageLoader } from '../../components/feedback/States.jsx'
import { useAuth } from './AuthContext.jsx'
import { hasPermission, hasAnyPermission } from '../../lib/permissions.js'

export function ProtectedRoute({ roles, permission, anyOf }) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) return <PageLoader label="Memeriksa sesi" />
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />
  if (user.status === 'SUSPENDED') return <Navigate to="/account-suspended" replace />
  if (!user.role || !user.profileComplete) return <Navigate to="/onboarding" replace />
  if (roles && !roles.includes(user.role) && !(user.role === 'SUPERADMIN' && roles.includes('ADMIN'))) {
    return <Navigate to="/unauthorized" replace />
  }
  if (permission && !hasPermission(user, permission)) {
    return <Navigate to="/unauthorized" replace />
  }
  if (anyOf && !hasAnyPermission(user, anyOf)) {
    return <Navigate to="/unauthorized" replace />
  }
  return <Outlet />
}

export function PublicOnlyRoute() {
  const { user, loading, roleHome } = useAuth()
  if (loading) return <PageLoader label="Memeriksa sesi" />
  if (user?.status === 'SUSPENDED') return <Navigate to="/account-suspended" replace />
  if (user) {
    return !user.profileComplete ? <Navigate to="/onboarding" replace /> : <Navigate to={roleHome} replace />
  }
  return <Outlet />
}
